import secureApi from "../../utils/secureApi";

export interface VenueBasicDetails {
  name: string;
}

export interface VenueListItem {
  _id: string;
  basicDetails: VenueBasicDetails;
}

interface VenueListApiResponse {
  data?: {
    paginatedResults?: VenueListItem[];
  } | VenueListItem[];
}

/**
 * Fetch list of venues for scope ID selection.
 * Uses /api/v1/venues/list and normalizes to a flat array.
 */
export async function listVenuesForScope(): Promise<VenueListItem[]> {
  try {
    const response = await secureApi.get<VenueListApiResponse>(
      "/api/v1/venues/list"
    );

    if (Array.isArray(response)) {
      return response as VenueListItem[];
    }

    if (Array.isArray(response?.data)) {
      return response.data as VenueListItem[];
    }

    if (Array.isArray(response?.data?.paginatedResults)) {
      return response.data.paginatedResults as VenueListItem[];
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch venues for scope IDs:", error);
    return [];
  }
}

